var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('el-select',{attrs:{"clearable":"","placeholder":"请选择省份"},on:{"change":function($event){return _vm.changeCity()}},model:{value:(_vm.value),callback:function ($$v) {_vm.value=$$v},expression:"value"}},_vm._l((_vm.options),function(item){return _c('el-option',{key:item.value,attrs:{"label":item.label,"value":item.label}})}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }